import * as yup from 'yup';

import { useTranslations } from 'hooks/useTranslations';
import { countEditorCharacters } from 'components/organisms/HtmlSlate';

const useFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    trace: yup
      .string()
      .test('trace-required', t('general.field.validation.required'), (value, context) => {
        if (context.parent.trace === null || context.parent.trace === '') {
          return false;
        }
        return true;
      })
      .trim(),
    conclusions: yup
      .string()
      .nullable()
      .test('editor-required', t('general.field.validation.required'), (value, context) => {
        if (context.parent.trace?.toString() === 'true') {
          return countEditorCharacters(value) > 0;
        }
        return true;
      })
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '1000'),
        (value) => countEditorCharacters(value) <= 1000,
      )
      .trim(),
    attachments: yup.array().nullable(),
  });
  return { schema };
};

export default useFormSchema;
